import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { postAPI } from 'src/utils/api';
import qs from 'qs';
import { useNavigate, useLocation } from 'react-router-dom';

const cssTextField = {
  sx: {
    '& .MuiInputBase-input': { padding: '12px 12px' },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #BDBDBD',
    },
    '& input::placeholder': {
      fontSize: '14px',
      fontWeight: 400,
      color: '#AAB2BD',
      lineHeight: '14.4px',
      opacity: 1,
    },
    mb: '4px',
  },
};

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [returnTo, setReturnTo] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const returnTo = params.get('returnTo');

    if (returnTo) {
      setReturnTo(returnTo);
    }
  }, [navigate, location]);

  const handleLogin = () => {
    setError('');
    if (!username || !password) {
      setError('ユーザーIDとパスワードを入力してください');
      return;
    }

    // Implement login logic here
    const data = {
      username: username,
      password: password,
    };
    postAPI('/auth/login', qs.parse(data)).then((res) => {
      if (res.code === 200) {
        if (typeof window !== "undefined") {
          window.localStorage.setItem("auth_data", JSON.stringify(res.data));
          window.localStorage.setItem("auth_token", JSON.stringify(res.token));

          let permissionString = res.data.permission.join(',');
          
          window.localStorage.setItem('karte_permission', permissionString)
          window.localStorage.setItem('__user', JSON.stringify(res.data.user))
          window.localStorage.setItem('karte_token', res.token)
          window.localStorage.setItem('karte_status', JSON.stringify(res.data.reservestatus))

          window.sessionStorage.setItem('karte_permission', permissionString)
          window.sessionStorage.setItem('__user', JSON.stringify(res.data.user))
          window.sessionStorage.setItem('karte_token', res.token)
          window.sessionStorage.setItem('karte_status', JSON.stringify(res.data.reservestatus))
        }

        if (returnTo) {
          navigate(returnTo);
          return;
        }
        navigate('/reception');
      } else {
        setError('ユーザーIDかパスワードが間違っています');
      }
    });
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleLogin()
    }
    return;
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#E8F1FB',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '440px',
          minHeight: '424px',
          m: '0 auto',
        }}
      >
        <Paper
          sx={{
            padding: { xs: '16px', sm: '80px' },
            margin: { xs: '16px', sm: '0' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '12px',
            backgroundColor: 'primary.light',
            boxShadow: 'none',
          }}
        >
          <Box
            component='img'
            src='/images/icons/logo-arukaru-text.svg'
            alt='Icon Arukaru'
            sx={{ width: '164.78px', height: '28px' }}
          />
          <Box component='form' noValidate sx={{ mt: '24px' }}>
            {error && (
              <Box
                sx={{
                  width: '100%',
                  color: 'error.main',
                }}
              >
                {error}
              </Box>
            )}
            <TextField
              {...cssTextField}
              InputProps={{
                sx: {
                  width: { sm: '280px', xs: 'auto' },
                  height: '48px',
                },
              }}
              margin='normal'
              required
              fullWidth
              id='username'
              placeholder='ユーザーID'
              name='username'
              autoComplete='username'
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e)}
            />
            <TextField
              {...cssTextField}
              InputProps={{
                sx: {
                  width: { sm: '280px', xs: 'auto' },
                  height: '48px',
                },
              }}
              margin='normal'
              required
              fullWidth
              name='password'
              placeholder='パスワード'
              type='password'
              id='password'
              autoComplete='current-password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e)}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Button
                type='button'
                variant='contained'
                onClick={handleLogin}
                sx={{
                  mt: '36px',
                  minWidth: '120px',
                  height: '40px',
                  background:
                    'linear-gradient(95.64deg, #00C3FF 0%, #0090F8 100%)',
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: '16.8px',
                }}
              >
                ログイン
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default Login;
